import { AbsoluteFill, useVideoConfig } from 'remotion';

// Components
import { Confetti as ConfettiAnimation } from '@/components/common/ConfettiAnimation';

// Configuration
import {
  CONFETTI_CONFIG_SCENE2,
  DEFAULT_CONFETTI_COLORS,
} from '@/components/common/ConfettiAnimation/constants';

interface ConfettiProps {
  startFrame: number; // Frame when confetti fires
  zIndex?: number;
}

/**
 * Confetti effect with multiple burst locations.
 * When enableShades is true, uses the pre-blended shade palette.
 */
export const ConfettiScene2 = ({
  startFrame,
  zIndex = CONFETTI_CONFIG_SCENE2.Z_INDEX,
}: ConfettiProps) => {
  const { width, height } = useVideoConfig();

  const {
    PARTICLES_PER_BURST,
    ANGLE,
    SPREAD,
    TICKS,
    GRAVITY,
    SCALAR,
    DRIFT,
    START_VELOCITY,
    DECAY,
    SHAPES,
    BURST_LOCATIONS,
  } = CONFETTI_CONFIG_SCENE2;

  return (
    <AbsoluteFill style={{ pointerEvents: 'none', zIndex }}>
      {BURST_LOCATIONS.map(({ x, ratio }, index) => (
        <ConfettiAnimation
          key={index}
          fireAtFrame={startFrame}
          x={width * x}
          y={0}
          width={width}
          height={height}
          particleCount={Math.floor(PARTICLES_PER_BURST * ratio)}
          angle={ANGLE}
          spread={SPREAD}
          ticks={TICKS}
          gravity={GRAVITY}
          scalar={SCALAR}
          drift={DRIFT}
          startVelocity={START_VELOCITY}
          decay={DECAY}
          colors={DEFAULT_CONFETTI_COLORS}
          shapes={SHAPES}
        />
      ))}
    </AbsoluteFill>
  );
};
